interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, current - 2);
  const end = Math.min(total, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const btnBase =
    'min-w-9 h-9 px-3 rounded-md text-sm flex items-center justify-center transition-colors cursor-pointer';

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 mt-10">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${btnBase} bg-background-200 text-foreground-700 hover:bg-background-300 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap`}
      >
        <i className="ri-arrow-left-s-line text-lg" /> 上一页
      </button>

      {start > 1 && (
        <>
          <button
            type="button"
            onClick={() => onChange(1)}
            className={`${btnBase} bg-background-200 text-foreground-700 hover:bg-background-300`}
          >
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-500">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${btnBase} ${
            p === current
              ? 'bg-primary-500 text-background-50 font-semibold'
              : 'bg-background-200 text-foreground-700 hover:bg-background-300'
          }`}
        >
          {p}
        </button>
      ))}

      {end < total && (
        <>
          {end < total - 1 && <span className="px-1 text-foreground-500">…</span>}
          <button
            type="button"
            onClick={() => onChange(total)}
            className={`${btnBase} bg-background-200 text-foreground-700 hover:bg-background-300`}
          >
            {total}
          </button>
        </>
      )}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className={`${btnBase} bg-background-200 text-foreground-700 hover:bg-background-300 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap`}
      >
        下一页 <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </div>
  );
}